"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var TableActionComment_1 = require("../../../../../../../../shared/components/table_actions/TableActionComment");
var BrandBlackIpList = /** @class */ (function (_super) {
    __extends(BrandBlackIpList, _super);
    function BrandBlackIpList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'IP адрес',
                dataIndex: _this.props.data.dk_ip_address,
                key: _this.props.data.dk_ip_address,
                width: 200,
            }, {
                title: 'Добавлено',
                dataIndex: _this.props.data.dk_date_added2,
                key: _this.props.data.dk_date_added2,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Описание',
                dataIndex: _this.props.data.dk_description,
                key: _this.props.data.dk_description,
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionComment_1.default, { hint: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439", onClick: function () { _this.onCommentClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 80
            }
        ];
        return _this;
    }
    BrandBlackIpList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat,
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: [],
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
    };
    BrandBlackIpList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    BrandBlackIpList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
                // nextProps.dataLogs.LoadData(this.props.player.key);
            });
        }
    };
    BrandBlackIpList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            brand_id: Props.rootRecord.key,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    BrandBlackIpList.prototype.onCommentClick = function (record) {
        var _this = this;
        this.props.dlgDescriptionEditor.SetTitle("Изменить описание").SetDescription(record.description).SetOnYesClick(function (description) {
            _this.props.data.SetDescription(record.key, description, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 ip \u0430\u0434\u0440\u0435\u0441\u0430 ",
                    React.createElement("b", null,
                        "[",
                        record.ip_address,
                        "]"),
                    " \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E"));
            });
        }).Show();
    };
    BrandBlackIpList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "IP \u0430\u0434\u0440\u0435\u0441 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandBlackIpList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            /*this.props.dataLogs.LoadData(this.props.player.key, () => {
                if (this.props.onPageConfigChanged) {
                    this.props.onPageConfigChanged(_page, PageSize);
                }
            });*/
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    BrandBlackIpList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            //this.props.dataLogs.LoadData(this.props.player.key);
            this.loadData(this.props);
        }
        if (action === "create") {
            this.props.dlgWhiteIpEditor.clearFields().SetDialogTitle("Добавить ip адрес")
                .SetMessageBody("")
                .SetMessageTitle("")
                .SetOnYesClick(function (ipAddr, Description /*, isHasPromo, promoCode, isImportant*/) {
                _this.props.data.AddData({
                    brand_id: _this.props.rootRecord.key,
                    ip_address: ipAddr,
                    description: Description,
                }, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "IP \u0430\u0434\u0440\u0435\u0441 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D !"));
                });
            }).Show();
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BrandBlackIpList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    BrandBlackIpList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Создать", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.state.dtFormat),
                            "] ")));
                } })));
    };
    return BrandBlackIpList;
}(React.Component));
exports.default = BrandBlackIpList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/black_ip/BrandBlackIpList.tsx
// module id = 1803
// module chunks = 0